<template>
    <cadastro-simples-list
        endpoint="tipo-ocorrencia"
        rota-base="/admin/tipo-ocorrencia"
        titulo="TIPOS DE OCORRÊNCIA"
        titulo-singular="Tipo de Ocorrência"
        :colunas-extras='[
            { campo: "descricao", label: "Descrição", tipo: "string" }
        ]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
